/* import __COLOCATED_TEMPLATE__ from './impersonate-button.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type Session from 'embercom/services/session';
import type IntlService from 'embercom/services/intl';
import { dropTask } from 'ember-concurrency-decorators';

import type User from 'embercom/objects/inbox/user';
import { impersonateInRegion } from 'embercom/lib/impersonate';
import { HotkeyID } from 'embercom/services/inbox-hotkeys/HotkeyID';
import { type Hotkey } from 'embercom/services/inbox-hotkeys';
import type InboxHotkeys from 'embercom/services/inbox-hotkeys';

interface Args {
  user: User;
}

interface Signature {
  Args: Args;
}

export default class ImpersonateButton extends Component<Signature> {
  @service declare session: Session;
  @service declare intl: IntlService;
  @service declare inboxHotkeys: InboxHotkeys;
  @service('browser/window') declare windowService: Window;

  readonly handleNotEditorHotkey;
  readonly impersonateHotkey: Hotkey;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.handleNotEditorHotkey = this.inboxHotkeys.handleNotEditorHotkey;
    this.impersonateHotkey = this.inboxHotkeys.hotkeysMap[HotkeyID.Impersonate];
  }

  get impersonateDropdownListItems() {
    return [
      {
        items: [
          {
            text: this.intl.t('inbox.impersonate-button.dropdown.us'),
            value: 'us-east-1',
          },
          {
            text: this.intl.t('inbox.impersonate-button.dropdown.eu'),
            value: 'eu-west-1',
          },
          {
            text: this.intl.t('inbox.impersonate-button.dropdown.au'),
            value: 'ap-southeast-2',
          },
        ],
      },
    ];
  }

  get isIntercomradesDomain() {
    return this.windowService.location.hostname.includes('intercomrades');
  }

  get shouldDisplay() {
    return (
      this.isIntercomradesDomain &&
      (this.session.workspace.isIntercom || this.session.workspace.isFin4All()) &&
      this.args.user.hasUserRole
    );
  }

  get hasImpersonationConsent(): boolean {
    return this.args.user?.attributes?.custom_data?.has_impersonation_consent === true;
  }

  @action async impersonateUser(region: string) {
    impersonateInRegion(
      region,
      this.args.user.userId,
      this.args.user.email,
      this.session.workspace,
    );
  }

  @dropTask *impersonateUserUsEast1() {
    yield this.impersonateUser('us-east-1');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::ImpersonateButton': typeof ImpersonateButton;
    'inbox2/conversation-details-sidebar/sidebar-sections/impersonate-button': typeof ImpersonateButton;
  }
}
